<!-- Don't use this directly, use IconTvDecoder instead. -->

<template>
  <svg
    id="svg55"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    sodipodi:docname="tv_black_24dp_fixed.svg"
    inkscape:version="1.1 (c4e8f9e, 2021-05-24)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs59" />
    <sodipodi:namedview
      id="namedview57"
      pagecolor="#ffffff"
      borderColor="#666666"
      borderopacity="1.0"
      inkscape:pageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      showgrid="true"
      showguides="true"
      inkscape:guide-bbox="true"
      inkscape:snap-global="false"
      inkscape:zoom="22.627417"
      inkscape:cx="24.859223"
      inkscape:cy="6.8500969"
      inkscape:window-width="1920"
      inkscape:window-height="1043"
      inkscape:window-x="1920"
      inkscape:window-y="0"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg55"
    >
      <sodipodi:guide
        id="guide188"
        position="0.97841727,9.6690648"
        orientation="1,0"
      />
      <sodipodi:guide
        id="guide190"
        position="3.5881538,20.99539"
        orientation="0,-1"
      />
      <inkscape:grid
        id="grid424"
        type="xygrid"
      />
    </sodipodi:namedview>
    <g
      id="g1287"
      transform="matrix(0.8471627,0,0,0.8471627,0.16430735,3.7117363)"
    >
      <path
        id="path51"
        d="M 0,0 H 24 V 24 H 0 Z"
        fill="none"
      />
      <path
        id="path53"
        d="M 21,3 H 3 C 1.9,3 1,3.9 1,5 v 12 c 0,1.1 0.9,2 2,2 h 5 v 2 h 8 v -2 h 5 c 1.1,0 1.99,-0.9 1.99,-2 L 23,5 C 23,3.9 22.1,3 21,3 Z m 0,14 H 3 V 5 h 18 z"
      />
      <path
        id="path53-8"
        d="m 6.84375,-0.83984375 c -1.1,0 -2,0.90000007 -2,1.99999995 v 0.7988282 h 2 V 1.1601562 h 18 V 13.160156 h -0.837891 v 2 h 0.837891 c 1.1,0 1.990234,-0.9 1.990234,-2 l 0.0098,-11.9999998 c 0,-1.09999988 -0.9,-1.99999995 -2,-1.99999995 z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconTvLandscapeSlaves',
};
</script>

<style scoped>
svg {
  fill: currentColor;
  max-width: 24px;
  max-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/IconTvLandscapeSlaves.vue